/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  CollectionRecommendationResults,
  Course,
  CourseBookmarkInput,
  CourseFeedback,
  CourseRecommendationResults,
  CreatePinnedToolBody,
  ListCollectionRecommendationsParams,
  ListCourseRecommendationsParams,
  ListCourseRemindersParams,
  ListCoursesParams,
  ListEnrolledCoursesParams,
  ListPinnedToolsParams,
  ListUserPreferencesParams,
  PaginatedCourseFeedbacks,
  PaginatedCourseReminders,
  PaginatedCourses,
  PaginatedEnrolledCourses,
  PaginatedPinnedTools,
  PaginatedTeasers,
  PaginatedUserPreferences,
  PinnedTool,
  Profile,
  SchoolClassJoinInput,
  StandardError,
  TrackingEventInput,
  UpdateProfileBody,
  UpdateUserPreferenceBody,
  UserUnion
} from '../models';

import { axiosClient } from '../../internalAxiosClient';
import type { ErrorType } from '../../internalAxiosClient';
import { customQueryOptions } from '../../customQueryOptions';




/**
 * @summary Create Bookmark
 */
export const createCourseBookmark = (
    courseBookmarkInput: MaybeRef<CourseBookmarkInput>,
 signal?: AbortSignal
) => {
      courseBookmarkInput = unref(courseBookmarkInput);
      
      return axiosClient<Course>(
      {url: `/course_bookmark`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: courseBookmarkInput, signal
    },
      );
    }
  


export const getCreateCourseBookmarkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext> => {
    
const mutationKey = ['createCourseBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseBookmark>>, {data: CourseBookmarkInput}> = (props) => {
          const {data} = props ?? {};

          return  createCourseBookmark(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseBookmark>>>
    export type CreateCourseBookmarkMutationBody = CourseBookmarkInput
    export type CreateCourseBookmarkMutationError = ErrorType<void>

    /**
 * @summary Create Bookmark
 */
export const useCreateCourseBookmark = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createCourseBookmark>>,
        TError,
        {data: CourseBookmarkInput},
        TContext
      > => {

      const mutationOptions = getCreateCourseBookmarkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Bookmark
 */
export const deleteCourseBookmark = (
    courseBookmarkInput: MaybeRef<CourseBookmarkInput>,
 ) => {
      courseBookmarkInput = unref(courseBookmarkInput);
      
      return axiosClient<Course>(
      {url: `/course_bookmark`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: courseBookmarkInput
    },
      );
    }
  


export const getDeleteCourseBookmarkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext> => {
    
const mutationKey = ['deleteCourseBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourseBookmark>>, {data: CourseBookmarkInput}> = (props) => {
          const {data} = props ?? {};

          return  deleteCourseBookmark(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourseBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourseBookmark>>>
    export type DeleteCourseBookmarkMutationBody = CourseBookmarkInput
    export type DeleteCourseBookmarkMutationError = ErrorType<void>

    /**
 * @summary Delete Bookmark
 */
export const useDeleteCourseBookmark = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,{data: CourseBookmarkInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCourseBookmark>>,
        TError,
        {data: CourseBookmarkInput},
        TContext
      > => {

      const mutationOptions = getDeleteCourseBookmarkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Course Reminders
 */
export const listCourseReminders = (
    params?: MaybeRef<ListCourseRemindersParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedCourseReminders>(
      {url: `/course_reminders`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListCourseRemindersQueryKey = (params?: MaybeRef<ListCourseRemindersParams>,) => {
    return ['course_reminders', ...(params ? [params]: [])] as const;
    }

    
export const useListCourseRemindersQueryOptions = <TData = Awaited<ReturnType<typeof listCourseReminders>>, TError = ErrorType<void>>(params?: MaybeRef<ListCourseRemindersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseRemindersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseReminders>>> = ({ signal }) => listCourseReminders(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData> 
}

export type ListCourseRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseReminders>>>
export type ListCourseRemindersQueryError = ErrorType<void>


/**
 * @summary List of Course Reminders
 */

export function useListCourseReminders<TData = Awaited<ReturnType<typeof listCourseReminders>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListCourseRemindersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCourseRemindersQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Courses
 */
export const listCourses = (
    params?: MaybeRef<ListCoursesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedCourses>(
      {url: `/courses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListCoursesQueryKey = (params?: MaybeRef<ListCoursesParams>,) => {
    return ['courses', ...(params ? [params]: [])] as const;
    }

    
export const useListCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCoursesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourses>>> = ({ signal }) => listCourses(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData> 
}

export type ListCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listCourses>>>
export type ListCoursesQueryError = ErrorType<unknown>


/**
 * @summary List of Courses
 */

export function useListCourses<TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get a Course
 */
export const getCourse = (
    id: MaybeRef<number>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Course>(
      {url: `/courses/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetCourseQueryKey = (id: MaybeRef<number>,) => {
    return ['courses',id] as const;
    }

    
export const useGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<void>>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourse>>> = ({ signal }) => getCourse(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData> 
}

export type GetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourse>>>
export type GetCourseQueryError = ErrorType<void>


/**
 * @summary Get a Course
 */

export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<void>>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCourseQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Enrolled Courses
 */
export const listEnrolledCourses = (
    params?: MaybeRef<ListEnrolledCoursesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedEnrolledCourses>(
      {url: `/enrolled_courses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListEnrolledCoursesQueryKey = (params?: MaybeRef<ListEnrolledCoursesParams>,) => {
    return ['enrolled_courses', ...(params ? [params]: [])] as const;
    }

    
export const useListEnrolledCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listEnrolledCourses>>, TError = ErrorType<void>>(params?: MaybeRef<ListEnrolledCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListEnrolledCoursesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrolledCourses>>> = ({ signal }) => listEnrolledCourses(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData> 
}

export type ListEnrolledCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrolledCourses>>>
export type ListEnrolledCoursesQueryError = ErrorType<void>


/**
 * @summary List of Enrolled Courses
 */

export function useListEnrolledCourses<TData = Awaited<ReturnType<typeof listEnrolledCourses>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListEnrolledCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListEnrolledCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get a featured Course Feedback
 */
export const getFeaturedCourseFeedback = (
    courseId: MaybeRef<number>,
 signal?: AbortSignal
) => {
      courseId = unref(courseId);
      
      return axiosClient<CourseFeedback>(
      {url: `/courses/${courseId}/feedbacks/featured`, method: 'GET', signal
    },
      );
    }
  

const getGetFeaturedCourseFeedbackQueryKey = (courseId: MaybeRef<number>,) => {
    return ['courses',courseId,'feedbacks','featured'] as const;
    }

    
export const useGetFeaturedCourseFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError = ErrorType<unknown>>(courseId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFeaturedCourseFeedbackQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>> = ({ signal }) => getFeaturedCourseFeedback(courseId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData> 
}

export type GetFeaturedCourseFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>>
export type GetFeaturedCourseFeedbackQueryError = ErrorType<unknown>


/**
 * @summary Get a featured Course Feedback
 */

export function useGetFeaturedCourseFeedback<TData = Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError = ErrorType<unknown>>(
 courseId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeaturedCourseFeedback>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetFeaturedCourseFeedbackQueryOptions(courseId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List Course Feedbacks
 */
export const listCourseFeedbacks = (
    courseId: MaybeRef<number>,
 signal?: AbortSignal
) => {
      courseId = unref(courseId);
      
      return axiosClient<PaginatedCourseFeedbacks>(
      {url: `/courses/${courseId}/feedbacks`, method: 'GET', signal
    },
      );
    }
  

const getListCourseFeedbacksQueryKey = (courseId: MaybeRef<number>,) => {
    return ['courses',courseId,'feedbacks'] as const;
    }

    
export const useListCourseFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof listCourseFeedbacks>>, TError = ErrorType<unknown>>(courseId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseFeedbacksQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseFeedbacks>>> = ({ signal }) => listCourseFeedbacks(courseId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData> 
}

export type ListCourseFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseFeedbacks>>>
export type ListCourseFeedbacksQueryError = ErrorType<unknown>


/**
 * @summary List Course Feedbacks
 */

export function useListCourseFeedbacks<TData = Awaited<ReturnType<typeof listCourseFeedbacks>>, TError = ErrorType<unknown>>(
 courseId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseFeedbacks>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCourseFeedbacksQueryOptions(courseId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get a Course Feedback
 */
export const getCourseFeedback = (
    courseId: MaybeRef<number>,
    id: MaybeRef<number>,
 signal?: AbortSignal
) => {
      courseId = unref(courseId);
id = unref(id);
      
      return axiosClient<CourseFeedback>(
      {url: `/courses/${courseId}/feedbacks/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetCourseFeedbackQueryKey = (courseId: MaybeRef<number>,
    id: MaybeRef<number>,) => {
    return ['courses',courseId,'feedbacks',id] as const;
    }

    
export const useGetCourseFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getCourseFeedback>>, TError = ErrorType<unknown>>(courseId: MaybeRef<number>,
    id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseFeedbackQueryKey(courseId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseFeedback>>> = ({ signal }) => getCourseFeedback(courseId,id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData> 
}

export type GetCourseFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseFeedback>>>
export type GetCourseFeedbackQueryError = ErrorType<unknown>


/**
 * @summary Get a Course Feedback
 */

export function useGetCourseFeedback<TData = Awaited<ReturnType<typeof getCourseFeedback>>, TError = ErrorType<unknown>>(
 courseId: MaybeRef<number>,
    id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseFeedback>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCourseFeedbackQueryOptions(courseId,id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Creates a new pinned tool
 */
export const createPinnedTool = (
    createPinnedToolBody: MaybeRef<CreatePinnedToolBody>,
 signal?: AbortSignal
) => {
      createPinnedToolBody = unref(createPinnedToolBody);
      
      return axiosClient<PinnedTool>(
      {url: `/pinned_tools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPinnedToolBody, signal
    },
      );
    }
  


export const getCreatePinnedToolMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,{data: CreatePinnedToolBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,{data: CreatePinnedToolBody}, TContext> => {
    
const mutationKey = ['createPinnedTool'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinnedTool>>, {data: CreatePinnedToolBody}> = (props) => {
          const {data} = props ?? {};

          return  createPinnedTool(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePinnedToolMutationResult = NonNullable<Awaited<ReturnType<typeof createPinnedTool>>>
    export type CreatePinnedToolMutationBody = CreatePinnedToolBody
    export type CreatePinnedToolMutationError = ErrorType<void>

    /**
 * @summary Creates a new pinned tool
 */
export const useCreatePinnedTool = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,{data: CreatePinnedToolBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinnedTool>>,
        TError,
        {data: CreatePinnedToolBody},
        TContext
      > => {

      const mutationOptions = getCreatePinnedToolMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of pinned tools
 */
export const listPinnedTools = (
    params?: MaybeRef<ListPinnedToolsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedPinnedTools>(
      {url: `/pinned_tools`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListPinnedToolsQueryKey = (params?: MaybeRef<ListPinnedToolsParams>,) => {
    return ['pinned_tools', ...(params ? [params]: [])] as const;
    }

    
export const useListPinnedToolsQueryOptions = <TData = Awaited<ReturnType<typeof listPinnedTools>>, TError = ErrorType<void>>(params?: MaybeRef<ListPinnedToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPinnedToolsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPinnedTools>>> = ({ signal }) => listPinnedTools(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData> 
}

export type ListPinnedToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listPinnedTools>>>
export type ListPinnedToolsQueryError = ErrorType<void>


/**
 * @summary List of pinned tools
 */

export function useListPinnedTools<TData = Awaited<ReturnType<typeof listPinnedTools>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListPinnedToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPinnedToolsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Deletes a pinned tool
 */
export const deletePinnedTool = (
    namespace: MaybeRef<string>,
 ) => {
      namespace = unref(namespace);
      
      return axiosClient<void>(
      {url: `/pinned_tools/${namespace}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePinnedToolMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,{namespace: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,{namespace: string}, TContext> => {
    
const mutationKey = ['deletePinnedTool'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinnedTool>>, {namespace: string}> = (props) => {
          const {namespace} = props ?? {};

          return  deletePinnedTool(namespace,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePinnedToolMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinnedTool>>>
    
    export type DeletePinnedToolMutationError = ErrorType<void>

    /**
 * @summary Deletes a pinned tool
 */
export const useDeletePinnedTool = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,{namespace: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinnedTool>>,
        TError,
        {namespace: string},
        TContext
      > => {

      const mutationOptions = getDeletePinnedToolMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get Profile
 */
export const getProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<Profile>(
      {url: `/profile`, method: 'GET', signal
    },
      );
    }
  

const getGetProfileQueryKey = () => {
    return ['profile'] as const;
    }

    
export const useGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> 
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = ErrorType<void>


/**
 * @summary Get Profile
 */

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfileQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Profile
 */
export const updateProfile = (
    updateProfileBody: MaybeRef<UpdateProfileBody>,
 ) => {
      updateProfileBody = unref(updateProfileBody);
      
      return axiosClient<void>(
      {url: `/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProfileBody
    },
      );
    }
  


export const getUpdateProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateProfileBody}, TContext> => {
    
const mutationKey = ['updateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: UpdateProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateProfileBody
    export type UpdateProfileMutationError = ErrorType<unknown>

    /**
 * @summary Update Profile
 */
export const useUpdateProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateProfileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: UpdateProfileBody},
        TContext
      > => {

      const mutationOptions = getUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Course Recommendations
 */
export const listCourseRecommendations = (
    params?: MaybeRef<ListCourseRecommendationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<CourseRecommendationResults>(
      {url: `/recommendations/courses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListCourseRecommendationsQueryKey = (params?: MaybeRef<ListCourseRecommendationsParams>,) => {
    return ['recommendations','courses', ...(params ? [params]: [])] as const;
    }

    
export const useListCourseRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listCourseRecommendations>>, TError = ErrorType<StandardError>>(params?: MaybeRef<ListCourseRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseRecommendationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseRecommendations>>> = ({ signal }) => listCourseRecommendations(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData> 
}

export type ListCourseRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseRecommendations>>>
export type ListCourseRecommendationsQueryError = ErrorType<StandardError>


/**
 * @summary List of Course Recommendations
 */

export function useListCourseRecommendations<TData = Awaited<ReturnType<typeof listCourseRecommendations>>, TError = ErrorType<StandardError>>(
 params?: MaybeRef<ListCourseRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseRecommendations>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCourseRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Collection Recommendations
 */
export const listCollectionRecommendations = (
    params?: MaybeRef<ListCollectionRecommendationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<CollectionRecommendationResults>(
      {url: `/recommendations/collections`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListCollectionRecommendationsQueryKey = (params?: MaybeRef<ListCollectionRecommendationsParams>,) => {
    return ['recommendations','collections', ...(params ? [params]: [])] as const;
    }

    
export const useListCollectionRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof listCollectionRecommendations>>, TError = ErrorType<StandardError>>(params?: MaybeRef<ListCollectionRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCollectionRecommendationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollectionRecommendations>>> = ({ signal }) => listCollectionRecommendations(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData> 
}

export type ListCollectionRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollectionRecommendations>>>
export type ListCollectionRecommendationsQueryError = ErrorType<StandardError>


/**
 * @summary List of Collection Recommendations
 */

export function useListCollectionRecommendations<TData = Awaited<ReturnType<typeof listCollectionRecommendations>>, TError = ErrorType<StandardError>>(
 params?: MaybeRef<ListCollectionRecommendationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollectionRecommendations>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCollectionRecommendationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Join SchoolClass
 */
export const joinSchoolClass = (
    schoolClassJoinInput: MaybeRef<SchoolClassJoinInput>,
 signal?: AbortSignal
) => {
      schoolClassJoinInput = unref(schoolClassJoinInput);
      
      return axiosClient<UserUnion>(
      {url: `/school_classes/join`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassJoinInput, signal
    },
      );
    }
  


export const getJoinSchoolClassMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,{data: SchoolClassJoinInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,{data: SchoolClassJoinInput}, TContext> => {
    
const mutationKey = ['joinSchoolClass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinSchoolClass>>, {data: SchoolClassJoinInput}> = (props) => {
          const {data} = props ?? {};

          return  joinSchoolClass(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof joinSchoolClass>>>
    export type JoinSchoolClassMutationBody = SchoolClassJoinInput
    export type JoinSchoolClassMutationError = ErrorType<void>

    /**
 * @summary Join SchoolClass
 */
export const useJoinSchoolClass = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,{data: SchoolClassJoinInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof joinSchoolClass>>,
        TError,
        {data: SchoolClassJoinInput},
        TContext
      > => {

      const mutationOptions = getJoinSchoolClassMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Active Teasers
 */
export const listActiveTeasers = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedTeasers>(
      {url: `/teasers`, method: 'GET', signal
    },
      );
    }
  

const getListActiveTeasersQueryKey = () => {
    return ['teasers'] as const;
    }

    
export const useListActiveTeasersQueryOptions = <TData = Awaited<ReturnType<typeof listActiveTeasers>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListActiveTeasersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveTeasers>>> = ({ signal }) => listActiveTeasers(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData> 
}

export type ListActiveTeasersQueryResult = NonNullable<Awaited<ReturnType<typeof listActiveTeasers>>>
export type ListActiveTeasersQueryError = ErrorType<void>


/**
 * @summary List of Active Teasers
 */

export function useListActiveTeasers<TData = Awaited<ReturnType<typeof listActiveTeasers>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActiveTeasers>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListActiveTeasersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Tracking Event
 */
export const createTrackingEvent = (
    trackingEventInput: MaybeRef<TrackingEventInput>,
 signal?: AbortSignal
) => {
      trackingEventInput = unref(trackingEventInput);
      
      return axiosClient<void>(
      {url: `/tracking_events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackingEventInput, signal
    },
      );
    }
  


export const getCreateTrackingEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext> => {
    
const mutationKey = ['createTrackingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrackingEvent>>, {data: TrackingEventInput}> = (props) => {
          const {data} = props ?? {};

          return  createTrackingEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTrackingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createTrackingEvent>>>
    export type CreateTrackingEventMutationBody = TrackingEventInput
    export type CreateTrackingEventMutationError = ErrorType<void>

    /**
 * @summary Create Tracking Event
 */
export const useCreateTrackingEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createTrackingEvent>>,
        TError,
        {data: TrackingEventInput},
        TContext
      > => {

      const mutationOptions = getCreateTrackingEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of User Preferences
 */
export const listUserPreferences = (
    params?: MaybeRef<ListUserPreferencesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedUserPreferences>(
      {url: `/user_preferences`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListUserPreferencesQueryKey = (params?: MaybeRef<ListUserPreferencesParams>,) => {
    return ['user_preferences', ...(params ? [params]: [])] as const;
    }

    
export const useListUserPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<void>>(params?: MaybeRef<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListUserPreferencesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserPreferences>>> = ({ signal }) => listUserPreferences(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData> 
}

export type ListUserPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listUserPreferences>>>
export type ListUserPreferencesQueryError = ErrorType<void>


/**
 * @summary List of User Preferences
 */

export function useListUserPreferences<TData = Awaited<ReturnType<typeof listUserPreferences>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListUserPreferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPreferences>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListUserPreferencesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update/Create User Preference
 */
export const updateUserPreference = (
    updateUserPreferenceBody: MaybeRef<UpdateUserPreferenceBody>,
 signal?: AbortSignal
) => {
      updateUserPreferenceBody = unref(updateUserPreferenceBody);
      
      return axiosClient<void>(
      {url: `/user_preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserPreferenceBody, signal
    },
      );
    }
  


export const getUpdateUserPreferenceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext> => {
    
const mutationKey = ['updateUserPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserPreference>>, {data: UpdateUserPreferenceBody}> = (props) => {
          const {data} = props ?? {};

          return  updateUserPreference(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPreference>>>
    export type UpdateUserPreferenceMutationBody = UpdateUserPreferenceBody
    export type UpdateUserPreferenceMutationError = ErrorType<void>

    /**
 * @summary Update/Create User Preference
 */
export const useUpdateUserPreference = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreference>>, TError,{data: UpdateUserPreferenceBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserPreference>>,
        TError,
        {data: UpdateUserPreferenceBody},
        TContext
      > => {

      const mutationOptions = getUpdateUserPreferenceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Current User Details
 */
export const getMe = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<UserUnion>(
      {url: `/users/me`, method: 'GET', signal
    },
      );
    }
  

const getGetMeQueryKey = () => {
    return ['users','me'] as const;
    }

    
export const useGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> 
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Current User Details
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




